var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3129 18.8924L2.93056 33.7887C2.66827 33.9648 2.36536 34.0522 2.06559 34.0522C1.8033 34.0522 1.53786 33.9842 1.30059 33.8501C0.785298 33.5592 0.466797 33.0031 0.466797 32.397V2.6043C0.466797 1.9982 0.785298 1.44207 1.30059 1.15113C1.80645 0.863443 2.4403 0.881133 2.93056 1.21258L25.3129 16.1089C25.7689 16.4127 26.0467 16.9381 26.0467 17.5006C26.0467 18.0631 25.7689 18.5884 25.3129 18.8924Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play.67d6d1a120eb2063cdcd8268c05b2ca3.svg";